import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import UserService from '../../services/UserService.js';
import Utils from 'utils/Utils.js';
import AuthUtils from 'utils/AuthUtils.js';

import EnterGroupCode from './EnterGroupCode.js';

class EnterGroupCodeContainer extends Component {

    constructor(props){
		super(props);
		this.state = {valid:false,
                      showConfirm:false,
                      groupCode:'', 
                      error:''};    

		this.onChange = this.onChange.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
        this.onCancel  = this.onCancel.bind(this);
		this.isValid = this.isValid.bind(this);
    }

    componentWillMount() {
    }

    onConfirm() {
        this.setState({showConfirm:false});
        this.props.onSelectCompanyCode(this.state.groupCode);
    }

    onCancel() {
        this.setState({showConfirm:false});
    }

	onChange(event) {
		this.setState({groupCode: event.target.value}, this.isValid);
	}

	onSubmit(event) {
		console.log('onSubmit:' + JSON.stringify(this.state));

        if(this.isValid(true)) {
            if(this.props.isSwitch) {
                this.setState({showConfirm:true});
            } else {
                this.props.onSelectCompanyCode(this.state.groupCode);
            }
        }

		event.preventDefault();
	}
	
	isValid(submit) {
		var valid = Boolean(this.state.groupCode);


        this.setState({valid:valid});

		return valid;	
	}


    render() {
        var t = this.props.t; 
        return (
            <EnterGroupCode valid={this.state.valid}
                            error={this.state.error}
                            switchCompanyError={this.props.switchCompanyError}
                            groupCode={this.state.groupCode}
                            showConfirm={this.state.showConfirm}
                            onChange={this.onChange}
                            onSubmit={this.onSubmit}
                            onConfirm={this.onConfirm}
                            onCancel={this.onCancel}
                            onHideError={this.props.onHideError}/>
      );
  }
}

export default withRouter(connect()(translate('authentication')(EnterGroupCodeContainer)));



// WEBPACK FOOTER //
// ./src/modules/authentication/EnterGroupCodeContainer.js